(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gnd-contact-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('gnd-general-contact');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const preference = dialog.querySelector('#gnd-contact-preference');
  const phone = dialog.querySelector('#gnd-contact-phone');
  let opener;
  const open = (source) => {
    opener = source;
    if (!dialog.open) dialog.showModal();
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (link.closest('article[data-sku]') && document.getElementById('gnd-vault-inquiry')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/contact\/?$/i.test(url.pathname)) return;
    event.preventDefault();
    open(link);
  });
  dialog.querySelector('.gnd-contact-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
  preference.addEventListener('change', () => { phone.required = preference.value === 'Text message'; });
  const form = dialog.querySelector('form');
  form.addEventListener('submit', () => { sessionStorage.setItem('gnd-general-contact-pending','1'); });
  if (sessionStorage.getItem('gnd-general-contact-pending') === '1' && (location.hash === '#gnd-contact-sent' || dialog.querySelector('[data-contact-errors]'))) {
    open();
    sessionStorage.removeItem('gnd-general-contact-pending');
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gnd-inquiry-context"] && !Shopify.designMode) return;
  try {
    (() => {
  const parse = id => { try { return JSON.parse(document.getElementById(id)?.textContent || 'null'); } catch { return null; } };
  const copy = parse('gnd-inquiry-copy');
  if (!copy) return;
  const product = parse('gnd-inquiry-product');
  const clean = value => String(value || '').replace(/[\u0000-\u001f]/g,' ').trim().slice(0,1000);
  const safeUrl = value => { try { const url=new URL(value,location.origin); return url.origin===location.origin && /^\/(products|collections|pages)\//.test(url.pathname) ? url.origin+url.pathname+(url.searchParams.has('variant')?'?variant='+encodeURIComponent(url.searchParams.get('variant')):'') : ''; } catch { return ''; } };
  const field = (form,name,value) => { let input=form.elements.namedItem(name); if(!input){input=document.createElement('input');input.type='hidden';input.name=name;form.append(input);} input.value=value;input.disabled=!value; };
  const productContext = link => {
    if (!product) return null;
    const formId=link?.dataset.productForm || document.querySelector('[data-gnd-product-inquiry]')?.dataset.productForm;
    const selected=document.getElementById(formId)?.elements.namedItem('id')?.value || new URL(location.href).searchParams.get('variant') || product.selected;
    const variant=product.variants.find(v=>v.id===String(selected));
    if(!variant) return null;
    return {reference:variant.sku||product.title,details:product.title+(variant.title==='Default Title'?'':' — '+variant.title),url:safeUrl(variant.url),source:location.origin+location.pathname};
  };
  const fromUrl = url => ({reference:clean(url.searchParams.get('reference')),details:[clean(url.searchParams.get('product')),clean(url.searchParams.get('variant'))].filter(Boolean).join(' — '),url:safeUrl(url.searchParams.get('item_url')||(/^\d{6}$/.test(url.searchParams.get('reference')||'')?'/collections/miami-cuban-vault':'')),source:location.origin+location.pathname});
  const apply = (form,ctx) => {
    const fields=form.querySelector('[data-gnd-inquiry-fields]'); if(!fields) return;
    fields.querySelector('[data-gnd-reference]').value=ctx.reference||'';
    const details=fields.querySelector('[data-gnd-details]'); details.value=ctx.details||''; details.disabled=!ctx.details; fields.querySelector('[data-gnd-details-label]').hidden=!ctx.details;
    field(form,'contact[Product link]',ctx.url||'');
    field(form,'contact[Source page]',ctx.source||location.origin+location.pathname);
    field(form,'contact[Inquiry type]',ctx.reference||ctx.details?copy.item:copy.general);
    const message=form.elements.namedItem('contact[body]'); if(message) message.placeholder=ctx.reference||ctx.details?copy.message:'';
  };
  document.querySelectorAll('[data-gnd-inquiry-fields]').forEach(fields=>apply(fields.closest('form'),fromUrl(new URL(location.href))));
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]'); if(!link) return;
    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin || !/\/pages\/contact\/?$/.test(url.pathname)) return;
    let ctx=fromUrl(url);
    if(link.hasAttribute('data-gnd-product-inquiry') || (!ctx.reference && product)) ctx=productContext(link)||ctx;
    const card=link.closest('article[data-sku]');
    if(card){ctx.reference=card.dataset.sku;ctx.details=clean(card.querySelector('.prose')?.textContent);ctx.url=location.origin+location.pathname;}
    document.querySelectorAll('[data-gnd-inquiry-fields]').forEach(fields=>apply(fields.closest('form'),ctx));
    if(ctx.reference || ctx.details){
      url.searchParams.set('reference',ctx.reference);url.searchParams.set('product',ctx.details);url.searchParams.delete('variant');url.searchParams.set('item_url',ctx.url);link.href=url.href;
    }
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement) || !form.elements.namedItem('contact[email]')) return;
    field(form,'contact[Source page]',location.origin+location.pathname);
    const selected=form.elements.namedItem('contact[Selected piece]');
    if(selected && !selected.disabled && selected.value){
      const match=selected.value.match(/Reference\s+([^\s·]+)/i);
      if(match) field(form,'contact[Item reference]',match[1]);
      field(form,'contact[Product link]',location.origin+location.pathname);
    }
  },true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gnd-vault-search"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gnd-vault-search')){
  customElements.define('gnd-vault-search',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      const source=document.getElementById('gnd-vault-data');
      if(!source)return;
      try{this.catalog=JSON.parse(source.textContent);if(!this.words)this.words=JSON.parse(this.querySelector('[data-labels]').textContent);}catch{return;}
      this.ready=true;this.limit=this.dataset.mode==='full'?12:4;
      if(this.dataset.mode==='predictive'){
        this.input=this.closest('header-search')?.querySelector('input[name="q"]');
        this.onInput=()=>{this.limit=4;this.render(this.input.value);};
        this.input?.addEventListener('input',this.onInput);this.render(this.input?.value||'');
      }else this.render(this.dataset.query||'');
    }
    disconnectedCallback(){this.input?.removeEventListener('input',this.onInput);this.ready=false;}
    node(tag,cls,text){const n=document.createElement(tag);if(cls)n.className=cls;if(text!=null)n.textContent=text;return n;}
    matches(query){
      const normalized=query.toLowerCase().trim().replace(/[″”"]/g,' in ').replace(/\b(?:ref(?:erence)?|no|number)\.?\s*[:#-]?/g,'').replace(/\b(\d+(?:\.\d+)?)\s*(?:grams?|g)\b/g,'$1g').replace(/\b(\d+(?:\.\d+)?)\s*(?:karat|carat|kt|k)\b/g,'$1kt');
      if(normalized.length<2)return [];
      const tokens=normalized.split(/\s+/).filter(Boolean);
      return this.catalog.records.filter(r=>{if(this.catalog.onlineOffers?.[r.key]?.available===false)return false;const text=[r.sku,r.key,r.grams,r.grams==null?'':r.grams+'g',r.karat+'kt',r.color||'',r.width==null?'':r.width+'mm',r.width,r.length==null?'':r.length+'in',r.length,'solid gold miami cuban',r.type].join(' ').toLowerCase();return tokens.every(t=>text.includes(t));});
    }
    url(record){const offer=this.catalog.onlineOffers?.[record.key];if(offer?.available)return offer.url;const page=this.catalog.referencePages[record.sku];return page?(page+(record.piece?'?piece='+record.piece:'')):('/collections/miami-cuban-vault?ref='+encodeURIComponent(record.sku)+(record.piece?'&piece='+record.piece:''));}
    render(query){
      const records=this.matches(query);this.hidden=!records.length;this.dataset.hasResults=String(records.length>0);
      const native=this.closest('.shopify-section')?.querySelector('[data-gnd-native-search]');
      if(this.dataset.mode==='full'&&native)native.hidden=records.length>0&&Number(this.dataset.nativeCount)===0;
      if(!records.length)return;
      const heading=this.node(this.dataset.mode==='full'&&Number(this.dataset.nativeCount)===0?'h1':'h2','gnd-search-heading',this.words.title);
      const count=this.node('p','gnd-search-count',records.length+' '+(records.length===1?this.words.result:this.words.results));count.setAttribute('role','status');count.setAttribute('aria-live','polite');
      const children=[heading,count];
      if(this.dataset.mode==='full'){
        const form=this.node('form','gnd-search-form');form.action=this.dataset.searchUrl;form.method='get';form.setAttribute('role','search');
        const input=this.node('input');input.type='search';input.name='q';input.value=query;input.placeholder=this.words.placeholder;input.setAttribute('aria-label',this.words.placeholder);
        const button=this.node('button',null,this.words.search);button.type='submit';form.append(input,button);children.push(form);
      }
      const grid=this.node('div','gnd-search-grid');
      for(const r of records.slice(0,this.limit)){
        const a=this.node('a','gnd-search-card');a.href=this.url(r);
        const p=this.catalog.photos[r.key];
        if(p?.src){const img=this.node('img','gnd-search-photo');img.src=p.src;img.alt=p.alt||[r.grams==null?'':r.grams+'g',r.karat+'KT',r.color||'',r.type,this.words.reference,r.sku].join(' ');img.width=240;img.height=300;img.loading='lazy';a.append(img);}
        else a.append(this.node('span','gnd-search-photo gnd-search-placeholder',this.words.photo));
        const details=this.node('span','gnd-search-details');
        details.append(this.node('span','gnd-search-name',(r.grams==null?'':r.grams+'g ')+(r.color?r.color+' Gold ':'')+'Cuban '+r.type));
        details.append(this.node('span','gnd-search-specs',r.karat+'KT · '+(r.width==null?this.words.confirm:r.width+'mm')+' · '+(r.length==null?this.words.confirm:r.length+'″')));
        details.append(this.node('span','gnd-search-ref',this.words.reference+' '+r.sku+(r.piece?' · #'+r.piece:'')));
        details.append(this.node('span','gnd-search-view',this.words.view+' →'));a.append(details);grid.append(a);
      }
      children.push(grid);
      if(this.dataset.mode==='predictive'){
        const all=this.node('a','gnd-search-more',this.words.all);all.href=this.dataset.searchUrl+'?q='+encodeURIComponent(query);children.push(all);
      }else if(records.length>this.limit){const more=this.node('button','gnd-search-more',this.words.more);more.type='button';more.addEventListener('click',()=>{this.limit+=12;this.render(query);});children.push(more);}
      this.replaceChildren(...children);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
